import React from 'react';

export default function ConfirmModal({ show, title, message, confirmText = 'Delete', onConfirm, onClose, busy }) {
    if (!show) return null;
    return (
        <div className="modal d-block" tabIndex="-1" role="dialog" style={{ background: 'rgba(0,0,0,0.15)' }}>
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{title}</h5>
                        <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        <p className="mb-0">{message}</p>
                    </div>
                    <div className="modal-footer">
                        <button className="btn btn-outline-secondary" onClick={onClose} disabled={busy}>Cancel</button>
                        <button className="btn btn-danger" onClick={onConfirm} disabled={busy}>
                            {busy ? 'Deleting…' : confirmText}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
